import { render, staticRenderFns } from "./createMember.vue?vue&type=template&id=7824d854&"
import script from "./createMember.vue?vue&type=script&lang=js&"
export * from "./createMember.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports